import { useEffect, useState } from 'react';
import { Link, matchPath, Route, Routes, useLocation } from 'react-router-dom';
import { Layout, Menu, Typography } from 'antd';
import './App.less';
import { ColorGenerator, Home, Jinye, Participles, SuColour } from './routes';

const { Header, Footer, Sider, Content } = Layout;

const { Title } = Typography;

const menuItems = [
  {
    label: (
      <Link to="/">首页</Link>
    ),
    title: '首页',
    path: '/',
    key: 'home',
  },
  {
    label: (
      <Link to="participles">分词</Link>
    ),
    title: '分词',
    path: 'participles',
    key: 'participles',
  },
  {
    label: (
      <Link to="jinye">晋烨</Link>
    ),
    title: '晋烨',
    path: 'jinye',
    key: 'jinye',
  },
  {
    label: (
      <Link to="su-colour">SU上色</Link>
    ),
    title: 'SU上色',
    path: 'su-colour',
    key: 'su-colour',
  },
  {
    label: (
      <Link to="color-generator">颜色生成器</Link>
    ),
    title: '颜色生成器',
    path: 'color-generator',
    key: 'color-generator',
  },
];

function App() {
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const [title, setTitle] = useState('');
  const location = useLocation();
  
  useEffect(() => {
    const keys: string[] = [];
    menuItems.forEach(item => {
      if (matchPath(item.path, location.pathname)) {
        keys.push(item.key);
        setTitle(item.title);
      }
    });
    setSelectedKeys(keys);
  }, [location]);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider>
        <div className="logo"></div>
        <Menu items={menuItems} theme="dark" selectedKeys={selectedKeys} />
      </Sider>
      <Layout>
        <Header style={{ background: 'white', padding: '0 16px', display: 'flex', alignItems: 'center' }}>
          <Title level={3}>{title}</Title>
        </Header>
        <Content style={{ margin: 16, background: 'white', padding: 16 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="participles" element={<Participles />} />
            <Route path="jinye" element={<Jinye />} />
            <Route path="su-colour" element={<SuColour />} />
            <Route path="color-generator" element={<ColorGenerator />} />
          </Routes>
        </Content>
        <Footer></Footer>
      </Layout>
    </Layout>
  );
}

export default App;
